import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import * as globals from './components/GlobalScripts.js';
import './styles/GlobalStyles.css';
import ScrollToTop from './pages/ScrollToTop';
import Profesional from './pages/Profesional';
import Profesional_home from './pages/profesional/Profesional_home';
import Profesional_cuenta from './pages/profesional/Profesional_cuenta';
import Profesional_direccion from './pages/profesional/Profesional_direccion';
import Profesional_perfil from './pages/profesional/Profesional_perfil';
import Profesional_portafolio from './pages/profesional/Profesional_portafolio';
import Profesional_MetodoDePago from './pages/profesional/Profesional_MetodoDePago';
import Profesional_Membresia from './pages/profesional/Profesional_Membresia';
import Profesional_Membresia_TY from './pages/profesional/Profesional_Membresia_TY';
import Cliente from './pages/Cliente';
import Cliente_home from './pages/cliente/Cliente_home';
import Cliente_cuenta from './pages/cliente/Cliente_cuenta';
import Cliente_direccion from './pages/cliente/Cliente_direccion';
import Chat from './pages/Chat';
import Chat_home from './pages/chat/Chat_home';
import Home from './pages/Home';
import Categorias from './pages/Categorias';
import Profesional_home_public from './pages/profesional/Profesional_home_public';
import Quiero_contratar from './pages/Quiero_contratar';
import Quiero_trabajar from './pages/Quiero_trabajar';
import Login from './pages/Login';
import Terminos_condiciones from './pages/Terminos_condiciones';

const PrivateRoute = ({ children }) => {
    return globals.isAuthenticated() ? children : <Navigate to="/login" replace />;
  };

function App() {
    let user = JSON.parse(localStorage.getItem('user'));

    localStorage.setItem('path_api', 'https://donhonesto.zadrig.com/backend');

    useEffect(() => {
        globals.closeViewCharge();
    }, []);

    return (
        <Router>
          <ScrollToTop />
          <Routes>
            <Route
              path="/profesional/*"
              element={
                <PrivateRoute>
                  <Profesional />
                </PrivateRoute>
              }
            >
              <Route index element={<Profesional_home />} />
              <Route path="cuenta" element={<Profesional_cuenta />} />
              <Route path="direccion" element={<Profesional_direccion />} />
              <Route path="perfil" element={<Profesional_perfil />} />
              <Route path="portafolio" element={<Profesional_portafolio />} />
              <Route path="metodo-de-pago" element={<Profesional_MetodoDePago />} />
              <Route path="membresia" element={<Profesional_Membresia />} />
              <Route path="membresia/ty" element={<Profesional_Membresia_TY />} />
            </Route>
            <Route
              path="/cliente/*"
              element={
                <PrivateRoute>
                  <Cliente />
                </PrivateRoute>
              }
            >
              <Route index element={<Cliente_home />} />
              <Route path="cuenta" element={<Cliente_cuenta />} />
              <Route path="direccion" element={<Cliente_direccion />} />
            </Route>
            <Route
              path="/chat/:id"
              element={
                <PrivateRoute>
                  <Chat />
                </PrivateRoute>
              }
            >
              <Route index element={<Chat_home />} />
            </Route>
            <Route path="/" element={<Home />} />
            <Route path="/categorias" element={<Categorias />} />
            <Route path="/ver/profesional/:id" element={<Profesional_home_public />} />
            <Route path="/quiero-contratar" element={<Quiero_contratar />} />
            <Route path="/quiero-trabajar" element={<Quiero_trabajar />} />
            <Route path="/login" element={<Login />} />
            <Route path="/terminos-condiciones" element={<Terminos_condiciones />} />
          </Routes>
        </Router>
      );
}

export default App;
